import React from "react"
import { renderRichText,storyblokEditable } from "gatsby-source-storyblok"
import Button from "../../../components/button/button"
import Svg from "../../../components/icon_svg/icon_svg"
import Image from "../../../components/image/image"

const ScrollerSection = ({ blok }) => {
  if (typeof blok != "undefined") {
    const html = renderRichText(blok.text_content)
    const icon = {
      svg_icon: blok.Icon,
      link: { url: "" },
    }
    return (
      <div
        className="scroller-section"
        id={`${blok.title.toLowerCase()}_${blok._uid}`}
        {...storyblokEditable(blok)}
        key={blok._uid}
      >
        <div className="scroller-section__top">
          {blok.images &&
            blok.images
              .slice(0, 2)
              .map((image, index) => (
                <Image
                  blok={{ image }}
                  className={`scroller-section__image-${index}`}
                  key={`scroller-section__image-${index}`}
                  lazy={false}
                />
              ))}
          <Svg blok={icon} />
          <div className="scroller-section__box gs_reveal">
            <h3 className="scroller-section__title outline">{blok.title}</h3>
            <div
              className="scroller-section__content"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          </div>
        </div>
        <div className="scroller-section__bottom">
          {blok.cta_button &&
            blok.cta_button.map(blok => <Button key={blok._uid} blok={blok} />)}
        </div>
      </div>
    )
  }
}

export default ScrollerSection
